(self['webpackChunkheyholy_ss_theme'] =
  self['webpackChunkheyholy_ss_theme'] || []).push([
  ['/assets/vstar-rating-update'],
  {
    /***/ './src/assets/js/vstar-rating-update.js'() /*!**********************************************!*\
  !*** ./src/assets/js/vstar-rating-update.js ***!
  \**********************************************/
    {
      function _typeof(o) {
        '@babel/helpers - typeof';
        return (
          (_typeof =
            'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
              ? function (o) {
                  return typeof o;
                }
              : function (o) {
                  return o &&
                    'function' == typeof Symbol &&
                    o.constructor === Symbol &&
                    o !== Symbol.prototype
                    ? 'symbol'
                    : typeof o;
                }),
          _typeof(o)
        );
      }
      function _createForOfIteratorHelper(r, e) {
        var t =
          ('undefined' != typeof Symbol && r[Symbol.iterator]) ||
          r['@@iterator'];
        if (!t) {
          if (
            Array.isArray(r) ||
            (t = _unsupportedIterableToArray(r)) ||
            (e && r && 'number' == typeof r.length)
          ) {
            t && (r = t);
            var _n = 0,
              F = function F() {};
            return {
              s: F,
              n: function n() {
                return _n >= r.length
                  ? { done: !0 }
                  : { done: !1, value: r[_n++] };
              },
              e: function e(r) {
                throw r;
              },
              f: F,
            };
          }
          throw new TypeError(
            'Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
          );
        }
        var o,
          a = !0,
          u = !1;
        return {
          s: function s() {
            t = t.call(r);
          },
          n: function n() {
            var r = t.next();
            return (a = r.done), r;
          },
          e: function e(r) {
            (u = !0), (o = r);
          },
          f: function f() {
            try {
              a || null == t['return'] || t['return']();
            } finally {
              if (u) throw o;
            }
          },
        };
      }
      function _unsupportedIterableToArray(r, a) {
        if (r) {
          if ('string' == typeof r) return _arrayLikeToArray(r, a);
          var t = {}.toString.call(r).slice(8, -1);
          return (
            'Object' === t && r.constructor && (t = r.constructor.name),
            'Map' === t || 'Set' === t
              ? Array.from(r)
              : 'Arguments' === t ||
                /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)
              ? _arrayLikeToArray(r, a)
              : void 0
          );
        }
      }
      function _arrayLikeToArray(r, a) {
        (null == a || a > r.length) && (a = r.length);
        for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
        return n;
      }
      function _regenerator() {
        /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e,
          t,
          r = 'function' == typeof Symbol ? Symbol : {},
          n = r.iterator || '@@iterator',
          o = r.toStringTag || '@@toStringTag';
        function i(r, n, o, i) {
          var c = n && n.prototype instanceof Generator ? n : Generator,
            u = Object.create(c.prototype);
          return (
            _regeneratorDefine2(
              u,
              '_invoke',
              (function (r, n, o) {
                var i,
                  c,
                  u,
                  f = 0,
                  p = o || [],
                  y = !1,
                  G = {
                    p: 0,
                    n: 0,
                    v: e,
                    a: d,
                    f: d.bind(e, 4),
                    d: function d(t, r) {
                      return (i = t), (c = 0), (u = e), (G.n = r), a;
                    },
                  };
                function d(r, n) {
                  for (
                    c = r, u = n, t = 0;
                    !y && f && !o && t < p.length;
                    t++
                  ) {
                    var o,
                      i = p[t],
                      d = G.p,
                      l = i[2];
                    r > 3
                      ? (o = l === n) &&
                        ((u = i[(c = i[4]) ? 5 : ((c = 3), 3)]),
                        (i[4] = i[5] = e))
                      : i[0] <= d &&
                        ((o = r < 2 && d < i[1])
                          ? ((c = 0), (G.v = n), (G.n = i[1]))
                          : d < l &&
                            (o = r < 3 || i[0] > n || n > l) &&
                            ((i[4] = r), (i[5] = n), (G.n = l), (c = 0)));
                  }
                  if (o || r > 1) return a;
                  throw ((y = !0), n);
                }
                return function (o, p, l) {
                  if (f > 1) throw TypeError('Generator is already running');
                  for (
                    y && 1 === p && d(p, l), c = p, u = l;
                    (t = c < 2 ? e : u) || !y;

                  ) {
                    i ||
                      (c
                        ? c < 3
                          ? (c > 1 && (G.n = -1), d(c, u))
                          : (G.n = u)
                        : (G.v = u));
                    try {
                      if (((f = 2), i)) {
                        if ((c || (o = 'next'), (t = i[o]))) {
                          if (!(t = t.call(i, u)))
                            throw TypeError('iterator result is not an object');
                          if (!t.done) return t;
                          (u = t.value), c < 2 && (c = 0);
                        } else
                          1 === c && (t = i['return']) && t.call(i),
                            c < 2 &&
                              ((u = TypeError(
                                "The iterator does not provide a '" +
                                  o +
                                  "' method",
                              )),
                              (c = 1));
                        i = e;
                      } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
                        break;
                    } catch (t) {
                      (i = e), (c = 1), (u = t);
                    } finally {
                      f = 1;
                    }
                  }
                  return { value: t, done: y };
                };
              })(r, o, i),
              !0,
            ),
            u
          );
        }
        var a = {};
        function Generator() {}
        function GeneratorFunction() {}
        function GeneratorFunctionPrototype() {}
        t = Object.getPrototypeOf;
        var c = [][n]
            ? t(t([][n]()))
            : (_regeneratorDefine2((t = {}), n, function () {
                return this;
              }),
              t),
          u =
            (GeneratorFunctionPrototype.prototype =
            Generator.prototype =
              Object.create(c));
        function f(e) {
          return (
            Object.setPrototypeOf
              ? Object.setPrototypeOf(e, GeneratorFunctionPrototype)
              : ((e.__proto__ = GeneratorFunctionPrototype),
                _regeneratorDefine2(e, o, 'GeneratorFunction')),
            (e.prototype = Object.create(u)),
            e
          );
        }
        return (
          (GeneratorFunction.prototype = GeneratorFunctionPrototype),
          _regeneratorDefine2(u, 'constructor', GeneratorFunctionPrototype),
          _regeneratorDefine2(
            GeneratorFunctionPrototype,
            'constructor',
            GeneratorFunction,
          ),
          (GeneratorFunction.displayName = 'GeneratorFunction'),
          _regeneratorDefine2(
            GeneratorFunctionPrototype,
            o,
            'GeneratorFunction',
          ),
          _regeneratorDefine2(u),
          _regeneratorDefine2(u, o, 'Generator'),
          _regeneratorDefine2(u, n, function () {
            return this;
          }),
          _regeneratorDefine2(u, 'toString', function () {
            return '[object Generator]';
          }),
          (_regenerator = function _regenerator() {
            return { w: i, m: f };
          })()
        );
      }
      function _regeneratorDefine2(e, r, n, t) {
        var i = Object.defineProperty;
        try {
          i({}, '', {});
        } catch (e) {
          i = 0;
        }
        (_regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
          function o(r, n) {
            _regeneratorDefine2(e, r, function (e) {
              return this._invoke(r, n, e);
            });
          }
          r
            ? i
              ? i(e, r, {
                  value: n,
                  enumerable: !t,
                  configurable: !t,
                  writable: !t,
                })
              : (e[r] = n)
            : (o('next', 0), o('throw', 1), o('return', 2));
        }),
          _regeneratorDefine2(e, r, n, t);
      }
      function asyncGeneratorStep(n, t, e, r, o, a, c) {
        try {
          var i = n[a](c),
            u = i.value;
        } catch (n) {
          return void e(n);
        }
        i.done ? t(u) : Promise.resolve(u).then(r, o);
      }
      function _asyncToGenerator(n) {
        return function () {
          var t = this,
            e = arguments;
          return new Promise(function (r, o) {
            var a = n.apply(t, e);
            function _next(n) {
              asyncGeneratorStep(a, r, o, _next, _throw, 'next', n);
            }
            function _throw(n) {
              asyncGeneratorStep(a, r, o, _next, _throw, 'throw', n);
            }
            _next(void 0);
          });
        };
      }
      function _classCallCheck(a, n) {
        if (!(a instanceof n))
          throw new TypeError('Cannot call a class as a function');
      }
      function _defineProperties(e, r) {
        for (var t = 0; t < r.length; t++) {
          var o = r[t];
          (o.enumerable = o.enumerable || !1),
            (o.configurable = !0),
            'value' in o && (o.writable = !0),
            Object.defineProperty(e, _toPropertyKey(o.key), o);
        }
      }
      function _createClass(e, r, t) {
        return (
          r && _defineProperties(e.prototype, r),
          t && _defineProperties(e, t),
          Object.defineProperty(e, 'prototype', { writable: !1 }),
          e
        );
      }
      function _toPropertyKey(t) {
        var i = _toPrimitive(t, 'string');
        return 'symbol' == _typeof(i) ? i : i + '';
      }
      function _toPrimitive(t, r) {
        if ('object' != _typeof(t) || !t) return t;
        var e = t[Symbol.toPrimitive];
        if (void 0 !== e) {
          var i = e.call(t, r || 'default');
          if ('object' != _typeof(i)) return i;
          throw new TypeError('@@toPrimitive must return a primitive value.');
        }
        return ('string' === r ? String : Number)(t);
      }
      function _callSuper(t, o, e) {
        return (
          (o = _getPrototypeOf(o)),
          _possibleConstructorReturn(
            t,
            _isNativeReflectConstruct()
              ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor)
              : o.apply(t, e),
          )
        );
      }
      function _possibleConstructorReturn(t, e) {
        if (e && ('object' == _typeof(e) || 'function' == typeof e)) return e;
        if (void 0 !== e)
          throw new TypeError(
            'Derived constructors may only return object or undefined',
          );
        return _assertThisInitialized(t);
      }
      function _assertThisInitialized(e) {
        if (void 0 === e)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called",
          );
        return e;
      }
      function _inherits(t, e) {
        if ('function' != typeof e && null !== e)
          throw new TypeError(
            'Super expression must either be null or a function',
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          Object.defineProperty(t, 'prototype', { writable: !1 }),
          e && _setPrototypeOf(t, e);
      }
      function _wrapNativeSuper(t) {
        var r = 'function' == typeof Map ? new Map() : void 0;
        return (
          (_wrapNativeSuper = function _wrapNativeSuper(t) {
            if (null === t || !_isNativeFunction(t)) return t;
            if ('function' != typeof t)
              throw new TypeError(
                'Super expression must either be null or a function',
              );
            if (void 0 !== r) {
              if (r.has(t)) return r.get(t);
              r.set(t, Wrapper);
            }
            function Wrapper() {
              return _construct(
                t,
                arguments,
                _getPrototypeOf(this).constructor,
              );
            }
            return (
              (Wrapper.prototype = Object.create(t.prototype, {
                constructor: {
                  value: Wrapper,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
              _setPrototypeOf(Wrapper, t)
            );
          }),
          _wrapNativeSuper(t)
        );
      }
      function _construct(t, e, r) {
        if (_isNativeReflectConstruct())
          return Reflect.construct.apply(null, arguments);
        var o = [null];
        o.push.apply(o, e);
        var p = new (t.bind.apply(t, o))();
        return r && _setPrototypeOf(p, r.prototype), p;
      }
      function _isNativeReflectConstruct() {
        try {
          var t = !Boolean.prototype.valueOf.call(
            Reflect.construct(Boolean, [], function () {}),
          );
        } catch (t) {}
        return (_isNativeReflectConstruct =
          function _isNativeReflectConstruct() {
            return !!t;
          })();
      }
      function _isNativeFunction(t) {
        try {
          return -1 !== Function.toString.call(t).indexOf('[native code]');
        } catch (n) {
          return 'function' == typeof t;
        }
      }
      function _setPrototypeOf(t, e) {
        return (
          (_setPrototypeOf = Object.setPrototypeOf
            ? Object.setPrototypeOf.bind()
            : function (t, e) {
                return (t.__proto__ = e), t;
              }),
          _setPrototypeOf(t, e)
        );
      }
      function _getPrototypeOf(t) {
        return (
          (_getPrototypeOf = Object.setPrototypeOf
            ? Object.getPrototypeOf.bind()
            : function (t) {
                return t.__proto__ || Object.getPrototypeOf(t);
              }),
          _getPrototypeOf(t)
        );
      }
      var VstarRatingUpdate = /*#__PURE__*/ (function (_HTMLElement) {
        function VstarRatingUpdate() {
          var _this;
          _classCallCheck(this, VstarRatingUpdate);
          _this = _callSuper(this, VstarRatingUpdate);
          _this.productId = null;
          _this.defaultRating = null;
          _this.defaultCount = null;
          _this.observer = null;
          _this.fallbackTimeout = null;
          _this.initialized = false;
          return _this;
        }
        _inherits(VstarRatingUpdate, _HTMLElement);
        return _createClass(VstarRatingUpdate, [
          {
            key: 'connectedCallback',
            value: function connectedCallback() {
              var _this2 = this;
              this.productId = this.getAttribute('data-product-id');
              this.defaultRating = this.getAttribute('data-default-rating');
              this.defaultCount = this.getAttribute('data-default-count');

              // If defer-init is set, wait for updateProduct() call (used in quiz context)
              if (this.hasAttribute('data-defer-init')) {
                this.showSkeleton();
                return;
              }
              if (!this.productId) {
                this.useFallback();
                return;
              }
              this.showSkeleton();

              // Try to get data from Vstar widget first
              var foundWidget = this.tryUpdateFromWidget();
              this.setupObserver();

              // Fallback timeout - if Vstar doesn't load in 3s, ensure fallback is shown
              this.fallbackTimeout = setTimeout(function () {
                if (!_this2.initialized) {
                  _this2.useFallback();
                }
              }, 3000);
            },
          },
          {
            key: 'disconnectedCallback',
            value: function disconnectedCallback() {
              if (this.observer) {
                this.observer.disconnect();
              }
              if (this.fallbackTimeout) {
                clearTimeout(this.fallbackTimeout);
              }
            },

            /**
             * Update widget with new product (called when product changes dynamically)
             * @param {string|number} newProductId - Shopify product ID
             * @param {string} handle - Product handle (unused, kept for API compatibility)
             * @param {object} metafields - Optional metafields with vstar data
             */
          },
          {
            key: 'updateProduct',
            value: function updateProduct(newProductId, handle) {
              var metafields =
                arguments.length > 2 && arguments[2] !== undefined
                  ? arguments[2]
                  : null;
              if (!newProductId) return;

              // Reset state
              this.initialized = false;

              // Clear existing timeout
              if (this.fallbackTimeout) {
                clearTimeout(this.fallbackTimeout);
              }

              // Disconnect old observer
              if (this.observer) {
                this.observer.disconnect();
                this.observer = null;
              }

              // Update product ID
              this.productId = String(newProductId);
              this.setAttribute('data-product-id', this.productId);

              // Update inner widget product ID and clear old content
              var innerWidget = this.querySelector(
                '.custom-vstar-rating-widget',
              );
              if (innerWidget) {
                innerWidget.setAttribute('data-product-id', this.productId);
                // Clear old vstar content to trigger re-render by Vstar script
                innerWidget.innerHTML = '';
              }

              // Update default values from metafields if provided
              if (
                metafields !== null &&
                metafields !== void 0 &&
                metafields.vstar
              ) {
                var rating = metafields.vstar.rating_value;
                var count = metafields.vstar.review_count;
                if (rating) {
                  this.defaultRating = String(rating);
                  this.setAttribute('data-default-rating', this.defaultRating);
                }
                if (count) {
                  this.defaultCount = String(count);
                  this.setAttribute('data-default-count', this.defaultCount);
                }
              }

              // Show skeleton while loading
              this.showSkeleton();
              this.classList.remove('tw-hidden');

              // Fetch rating data from custom JSON endpoint
              if (handle) {
                this.fetchRatingFromEndpoint(handle);
              } else {
                this.useDefaultOrHide();
              }
            },

            /**
             * Fetch rating data using Section Rendering API
             * @param {string} handle - Product handle
             */
          },
          {
            key: 'fetchRatingFromEndpoint',
            value: (function () {
              var _fetchRatingFromEndpoint = _asyncToGenerator(
                /*#__PURE__*/ _regenerator().m(function _callee(handle) {
                  var response,
                    sections,
                    html,
                    parser,
                    doc,
                    jsonScript,
                    data,
                    rating,
                    reviewCount,
                    _t;
                  return _regenerator().w(
                    function (_context) {
                      while (1)
                        switch ((_context.p = _context.n)) {
                          case 0:
                            _context.p = 0;
                            _context.n = 1;
                            return fetch(
                              '/products/'.concat(
                                handle,
                                '?sections=product-rating-data',
                              ),
                            );
                          case 1:
                            response = _context.v;
                            if (response.ok) {
                              _context.n = 2;
                              break;
                            }
                            throw new Error('Section rendering failed');
                          case 2:
                            _context.n = 3;
                            return response.json();
                          case 3:
                            sections = _context.v;
                            html = sections['product-rating-data']; // Parse JSON from section HTML
                            parser = new DOMParser();
                            doc = parser.parseFromString(html, 'text/html');
                            jsonScript = doc.querySelector(
                              '[data-product-rating]',
                            );
                            if (jsonScript) {
                              _context.n = 4;
                              break;
                            }
                            throw new Error('Rating data not found');
                          case 4:
                            data = JSON.parse(jsonScript.textContent);
                            rating = data.rating;
                            reviewCount = data.review_count;
                            if (
                              rating &&
                              reviewCount &&
                              rating !== '0' &&
                              reviewCount !== '0'
                            ) {
                              this.updateRatingElements(rating, reviewCount);
                              this.updateStarsFill(rating);
                              this.hideSkeleton();
                              this.classList.remove('tw-hidden');
                              this.initialized = true;
                            } else {
                              // No rating data - hide widget
                              this.classList.add('tw-hidden');
                              this.hideSkeleton();
                            }
                            _context.n = 6;
                            break;
                          case 5:
                            _context.p = 5;
                            _t = _context.v;
                            console.log(
                              'VstarRatingUpdate: Could not fetch rating',
                              _t,
                            );
                            this.useDefaultOrHide();
                          case 6:
                            return _context.a(2);
                        }
                    },
                    _callee,
                    this,
                    [[0, 5]],
                  );
                }),
              );
              function fetchRatingFromEndpoint(_x) {
                return _fetchRatingFromEndpoint.apply(this, arguments);
              }
              return fetchRatingFromEndpoint;
            })(),
            /**
             * Use default rating values or hide widget
             */
          },
          {
            key: 'useDefaultOrHide',
            value: function useDefaultOrHide() {
              // Re-read default attributes (they might have been updated)
              var defaultRating =
                this.getAttribute('data-default-rating') || this.defaultRating;
              var defaultCount =
                this.getAttribute('data-default-count') || this.defaultCount;
              if (
                defaultRating &&
                defaultCount &&
                defaultRating !== '0' &&
                defaultCount !== '0'
              ) {
                this.updateRatingElements(defaultRating, defaultCount);
                this.updateStarsFill(defaultRating);
                this.hideSkeleton();
                this.classList.remove('tw-hidden');
              } else {
                // No data at all - hide widget
                this.classList.add('tw-hidden');
                this.hideSkeleton();
              }
            },
          },
          {
            key: 'showSkeleton',
            value: function showSkeleton() {
              var skeleton = this.querySelector('[data-rating-skeleton]');
              var content = this.querySelector('[data-rating-content]');
              if (skeleton) skeleton.classList.remove('tw-hidden');
              if (content) content.classList.add('tw-hidden');
            },
          },
          {
            key: 'hideSkeleton',
            value: function hideSkeleton() {
              var skeleton = this.querySelector('[data-rating-skeleton]');
              var content = this.querySelector('[data-rating-content]');
              if (skeleton) skeleton.classList.add('tw-hidden');
              if (content) content.classList.remove('tw-hidden');
            },
          },
          {
            key: 'setupObserver',
            value: function setupObserver() {
              var _this3 = this;
              var widgetContainer = this.querySelector(
                '.custom-vstar-rating-widget',
              );
              if (!widgetContainer) return;
              this.observer = new MutationObserver(function (mutations) {
                var _iterator = _createForOfIteratorHelper(mutations),
                  _step;
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                    var mutation = _step.value;
                    if (
                      mutation.type === 'childList' ||
                      mutation.type === 'attributes'
                    ) {
                      _this3.tryUpdateFromWidget();
                    }
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
              });
              this.observer.observe(widgetContainer, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['rating', 'data-review-num'],
              });
            },
          },
          {
            key: 'tryUpdateFromWidget',
            value: function tryUpdateFromWidget() {
              var widget = this.querySelector(
                '.custom-vstar-rating-widget[data-product-id="'.concat(
                  this.productId,
                  '"] .vstar-star',
                ),
              );
              if (widget) {
                var rating = widget.getAttribute('rating');
                var reviewNum = widget.getAttribute('data-review-num');
                if (
                  rating &&
                  reviewNum &&
                  rating !== '0' &&
                  reviewNum !== '0'
                ) {
                  this.classList.remove('tw-hidden');
                  this.updateRatingElements(rating, reviewNum);
                  this.updateStarsFill(rating);
                  this.hideSkeleton();
                  this.initialized = true;
                  if (this.observer) {
                    this.observer.disconnect();
                    this.observer = null;
                  }
                  return true;
                }
              }
              return false;
            },
          },
          {
            key: 'useFallback',
            value: function useFallback() {
              if (
                this.defaultRating &&
                this.defaultCount &&
                this.defaultRating !== '0' &&
                this.defaultCount !== '0'
              ) {
                this.updateRatingElements(
                  this.defaultRating,
                  this.defaultCount,
                );
                this.updateStarsFill(this.defaultRating);
                this.classList.remove('tw-hidden');
                this.initialized = true;
              } else {
                // No valid fallback data - hide widget
                this.classList.add('tw-hidden');
              }
              this.hideSkeleton();
            },
          },
          {
            key: 'updateRatingElements',
            value: function updateRatingElements(rating, reviewNum) {
              var ratingElement = this.querySelector('[data-rating-value]');
              var countElement = this.querySelector('[data-review-count]');
              if (ratingElement && rating) {
                ratingElement.textContent = rating;
              }
              if (countElement && reviewNum) {
                countElement.textContent = reviewNum;
              }
            },
          },
          {
            key: 'updateStarsFill',
            value: function updateStarsFill(rating) {
              var starFill = this.querySelector('.star-fill');
              if (!starFill) return;
              var ratingValue = parseFloat(rating);
              if (isNaN(ratingValue) || ratingValue < 0 || ratingValue > 5) {
                return;
              }
              var fillPercentage = (ratingValue / 5) * 100;
              var unfilledPercentage = 100 - fillPercentage;
              starFill.style.width = ''.concat(unfilledPercentage, '%');
            },
          },
        ]);
      })(/*#__PURE__*/ _wrapNativeSuper(HTMLElement));
      if (!customElements.get('vstar-rating-update')) {
        customElements.define('vstar-rating-update', VstarRatingUpdate);
      }

      /***/
    },
  },
  /******/ (__webpack_require__) => {
    // webpackRuntimeModules
    /******/ var __webpack_exec__ = (moduleId) =>
      __webpack_require__((__webpack_require__.s = moduleId));
    /******/ var __webpack_exports__ = __webpack_exec__(
      './src/assets/js/vstar-rating-update.js',
    );
    /******/
  },
]);
